import React from 'react';
import StepCanvas from '../StepCanvas';
import type { DripVersion } from '../../../types';
type Props = {
    version: DripVersion | null;
    onEditSteps?: () => void;
    onEditTemplate?: (stepId: string) => void;
};
const Steps: React.FC<Props> = ({ version, onEditTemplate, onEditSteps }) => {
    if (!version && !onEditSteps) return null;
    return (
        <StepCanvas
            steps={version?.steps ?? []}
            entryStepId={version?.entry_step_id ?? null}
            onEditSteps={onEditSteps}
            onEditTemplate={onEditTemplate}
        />
    );
};
export default Steps;
